import { render } from "./veihcles.vue?vue&type=template&id=4c3fb544&scoped=true"
import script from "./veihcles.vue?vue&type=script&lang=js"
export * from "./veihcles.vue?vue&type=script&lang=js"

import "./veihcles.vue?vue&type=style&index=0&id=4c3fb544&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3fb544"]])

export default __exports__